import ApiService from "../../../ApiService";

const EditService = {
    loadScreenView: (id, sectionId, successCallback, failureCallback) => {
        ApiService.post("/web/admin/oralbook/editunit/loadscreenview", { id, sectionId }, successCallback, failureCallback);
    },
    saveUnit: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/oralbook/editunit/save", vo, successCallback, failureCallback);
    },
};

export default EditService;